<template>
  <div class="table-responsive">
    <table class="table table-striped shipping-methods">
      <tbody>
        <shipping-rate
          v-for="shippingRate in shippingRates"
          :key="shippingRate.shipping_method"
          :shipping-method="shippingRate.shipping_method"
          :timing="shippingRate.timing"
          :zone-discount="shippingRate.zone_discount"
          :notes="shippingRate.notes"
          :display-price="shippingRate.display_price"
          :promotion-discount="shippingRate.promotion_discount"
          :has-tracking="shippingRate.has_tracking"
          :saturday-delivery="shippingRate.saturday_delivery"
          :pickup-note="shippingRate.pick_up_note"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
  import ShippingRate from "./shipping-rate"

  export default {
    components: {
      ShippingRate,
    },
    props: {
      shippingRates: {
        type: Array,
        required: true,
      },
    },
  }
</script>
